// extracted by mini-css-extract-plugin
export default {"form":"PhysiciansCreateContainer_form__mAA+B"};